import { FormControlSizes, SearchSelect, useIntl, useWLOrgConfigContext } from '@talos/kyoko';
import { defineMessages } from 'react-intl';
import { useBlotterSettings } from './BlotterSettingsContext';

const messages = defineMessages({
  allOrders: {
    defaultMessage: 'All Orders',
    id: 'Blotters.allOrders',
  },
  myOrders: {
    defaultMessage: 'My Orders',
    id: 'Blotters.myOrders',
  },
  allTrades: {
    defaultMessage: 'All Trades',
    id: 'Blotters.allTrades',
  },
  myTrades: {
    defaultMessage: 'My Trades',
    id: 'Blotters.myTrades',
  },
});

interface ShowOnlySelfFilterProps {
  type: 'orders' | 'trades';
}

export function ShowOnlySelfFilter({ type }: ShowOnlySelfFilterProps) {
  const intl = useIntl();
  const { config } = useWLOrgConfigContext();
  const { showOnlySelfOrdersAndTrades, setShowOnlySelfOrdersAndTrades } = useBlotterSettings();

  if (config.hideBlotterUserFilterSelector) {
    return null;
  }

  const getLabel = (isMyFilter: boolean) => {
    const isOrders = type === 'orders';
    const allLabel = isOrders ? messages.allOrders : messages.allTrades;
    const myLabel = isOrders ? messages.myOrders : messages.myTrades;

    return intl.formatMessage(isMyFilter ? myLabel : allLabel);
  };

  return (
    <SearchSelect
      w="120px"
      data-testid={`show-only-self-${type}-select`}
      selection={showOnlySelfOrdersAndTrades}
      options={[false, true]}
      getLabel={getLabel}
      onChange={value => setShowOnlySelfOrdersAndTrades(value ?? false)}
      size={FormControlSizes.Small}
      showDropdownSearch={false}
      portalize
    />
  );
}
